// src/components/modals/ReportModal.jsx
import React, { useState } from 'react';
import { db } from '../../firebase';
import { doc, updateDoc } from 'firebase/firestore';

export const ReportModal = ({ sightingId, onClose, showToast }) => {
  const [reason, setReason] = useState("");
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!reason.trim()) return;
    await updateDoc(doc(db, "sightings", sightingId), { reported: true, reportReason: reason });
    showToast("Zgłoszenie wysłane");
    onClose();
  };
  
  return (
    <div className="fixed inset-0 bg-black/60 backdrop-blur-sm z-[550] flex items-center justify-center p-4">
      <div className="bg-white w-full max-w-sm p-6 rounded-2xl border border-gray-200">
        <h3 className="text-sm font-bold mb-4">Zgłoś problem</h3>
        <textarea 
          className="w-full bg-gray-50 p-3 rounded-xl text-sm border border-gray-200 h-32 mb-4 outline-none focus:ring-2 focus:ring-red-500 transition-all resize-none" 
          placeholder="Opisz problem..." 
          value={reason} 
          onChange={e => setReason(e.target.value)}
        />
        <div className="flex gap-2">
          <button onClick={onClose} className="flex-1 py-3 text-xs font-semibold text-gray-500 hover:bg-gray-100 rounded-lg transition-colors">
            Anuluj
          </button>
          <button onClick={handleSubmit} className="flex-1 py-3 bg-red-600 text-white rounded-lg text-xs font-semibold hover:bg-red-700 transition-colors">
            Zgłoś
          </button>
        </div>
      </div>
    </div>
  );
};